export const workExperienceListValue = [
  { id: 'experienceYears<=5', name: 'До 5 років' },
  { id: 'experienceYears>=6<=10', name: '6-10 років' },
  { id: 'experienceYears>=11<=15', name: '11-15 років' },
  { id: 'experienceYears>=16', name: '16 та більше років' },
];
